import axios from "axios";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;

export const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Access-Control-Allow-Methods": "*",
  },
});

axiosInstance.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response ? error.response.status : null;
    let errorMessage = "Что-то пошло не так!";

    if (status === 403) {
      errorMessage = error.response.data.message;
    } else if (status === 500) {
      errorMessage = "Внутренняя ошибка сервера";
    } else if (status === 422) {
      errorMessage = `${error.response.data.map((item: any) => item.message).join(", ")}`;
    }

    toast.error(errorMessage, {
      position: "bottom-right",
    });
    
    return Promise.reject(error);
  }
);

export const axiosInstanceWithoutToken = axios.create({
  baseURL: API_URL,
  headers: {
    "Access-Control-Allow-Methods": "*",
    "Content-Type": "multipart/form-data",
  },
});

axiosInstanceWithoutToken.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
